"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractUserInfoService = void 0;
const oidc_1 = require("../oidc");
/**
 * Returns UserInfo response
 * So we can fetch updated UserInfo tokens whenever we need to -
 * Check if roles have changed or similar
 *
 * Backed by oidc-client if on browser, openid-client if in Node
 */
class AbstractUserInfoService {
    constructor(authorityOrSettings) {
        this.authority =
            (typeof authorityOrSettings === "string"
                ? authorityOrSettings
                : authorityOrSettings.authority) ?? oidc_1.AUTHORITY_URL;
    }
}
exports.AbstractUserInfoService = AbstractUserInfoService;
